import { fetchFactory } from "../../../utils/fetchFactory";

export const loginUser = (googleResponse: object) => fetchFactory('/api/auth/token', {
    method: 'POST',
    body: JSON.stringify(googleResponse)
})